import { useEffect, useRef, useState, useCallback } from "react";
import { Monitor, Smartphone } from "lucide-react";
import { Button } from "@/components/ui/button";

export const VisualPreview = ({ content, pageId, onSelect }) => {
  const frame = useRef(null);
  const shell = useRef(null);
  const [mode, setMode] = useState("desktop");
  const [width, setWidth] = useState(800);
  const [ready, setReady] = useState(false);
  const viewport = mode === "mobile" ? 390 : 1440;
  const scale = Math.min(width / viewport, 1);
  const send = useCallback(() => frame.current?.contentWindow?.postMessage({ type: "meza-editor-preview", content, pageId }, window.location.origin), [content, pageId]);
  useEffect(() => {
    const observer = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width));
    if (shell.current) observer.observe(shell.current);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const receive = (event) => {
      if (event.origin !== window.location.origin || event.source !== frame.current?.contentWindow) return;
      if (event.data?.type === "meza-preview-ready") { setReady(true); send(); }
      if (event.data?.type === "meza-select-section") onSelect(event.data.id);
    };
    window.addEventListener("message", receive);
    return () => window.removeEventListener("message", receive);
  }, [send, onSelect]);
  useEffect(() => { if (ready) send(); }, [send, ready]);
  return <div data-testid="visual-preview-panel" className="min-w-0">
    <div className="flex items-center justify-between gap-3 mb-3"><span className="text-xs text-amber-300" data-testid="visual-preview-status">Private draft preview</span><div className="flex gap-1">{[["desktop", Monitor], ["mobile", Smartphone]].map(([value, Icon]) => <Button key={value} type="button" variant={mode === value ? "secondary" : "ghost"} size="icon" aria-pressed={mode === value} aria-label={`${value} preview`} title={`${value} preview`} data-testid={`preview-mode-${value}`} onClick={() => setMode(value)}><Icon className="w-4 h-4" /></Button>)}</div></div>
    <div ref={shell} className="visual-preview-shell" style={{ height: 650 }}>
      <iframe ref={frame} src="/admin/preview?embedded=1" title="Private website draft preview" data-testid="visual-editor-preview-frame" className="visual-preview-frame" onLoad={send} style={{ width: viewport, height: 650 / scale, transform: `scale(${scale})`, marginLeft: Math.max(0, (width - viewport) / 2) }} />
    </div>
  </div>;
};